
<div class="banner-container max-w-full ">
    <div class="w-full bg-overlay lg:bg-bottom bg-cover ">
        <fuse-alert
        *ngIf="showAlert"
        class="absolute top-4 left-4 z-50 max-w-sm"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type">
        {{ alert.message }}
    </fuse-alert>

        <div class="h-full absolute flex flex-col items-start mt-50 lg:mx-24 max-lg:px-4 ">

            <!-- <img class="w-14 h-14 pb-2" src="/assets/CellC_Assets/wifi.svg" alt="Wifi-img"> -->
                <h1 class="text-white md:text-center md:text-6xl text-4xl font-bold CellCSans">
                    Fibre to the home, fast.
                </h1> 
                <div class="font-semibold text-white flex justify-center mb-4 CellCSans">
                    Data that never runs out
                </div>
                <fuse-card class="rounded-full bg-white p-4 w-full shadow-none ">
                    <div class="flex flex-row justify-between items-center w-full ">
                        <div class="md:w-80 w-50 pr-2">
                            <input
                                onblur="this.placeholder = 'What is your address?'"
                                onfocus="this.placeholder = ''" id="searchTextField"
                                matInput
                                class="  text-ellipsis whitespace-nowrap placeholder:text-black bg-white w-full 
                                        font-light" type="text"
                                [(ngModel)]="location"  
                                placeholder="What is your address?"
                            >   
                        </div>
                        <div class="w-fit flex flex-row space-x-2 justify-end items-center">
                            <p 
                                (click)="getLocation()"
                                class="cursor-pointer mt-1 text-xs text-[#EA5B0C] font-semibold ">
                                  Use my current location
                            </p>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 14.2864C3.14864 15.1031 2 16.2412 2 17.5C2 19.9853 6.47715 22 12 22C17.5228 22 
                                    22 19.9853 22 17.5C22 16.2412 20.8514 15.1031 19 14.2864M18 8C18 12.0637 13.5 14 12 
                                    17C10.5 14 6 12.0637 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8ZM13 8C13
                                     8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 
                                     7 13 7.44772 13 8Z" 
                                     stroke="black" 
                                     stroke-width="2" 
                                     stroke-linecap="round" 
                                     stroke-linejoin="round"
                                />
                            </svg>    
                        </div>
                    </div>
                </fuse-card>
                <div class="flex flex-col items-center py-4" *ngIf="loading" >
                    <h1 class="text-2xl text-white mb-2 font-semibold">
                        Please wait while we fetch your packages...
                    </h1>
                    <mat-spinner diameter="72"></mat-spinner>
                </div>
                <div *ngIf="!loading">
                    <div *ngIf="showDropDownAlert">
                        <h1 class="text-lg font-semibold text-white">
                            Please enter a location and select from the drop down.
                        </h1>
                    </div>
                    <div class="flex flex-row pt-5 lg:space-x-2 max-lg:flex-col">
                        <button
                        id="checkCoverageBtn"
                        (click)="checkCoverageBtn_onClick()"
                        mat-flat-button 
                        class="flex items-center rounded-full px-8 py-4 bg-primary transition ease-in-out 
                                hover:-translate-y-1 hover:scale-100 duration-300">
                            <span class="flex items-center gap-x-3 text-black font-bold">
                                <span class="mb-0.5">Check coverage</span>
                                <!-- <mat-icon class="ml-2">keyboard_arrow_right</mat-icon> -->
                                <img class="icon-size-3" src="assets/CellC_Assets/cellc-check-coverage-arrow-right.svg">
                            </span>
                        </button>
                        <div *ngIf="!isLoggedIn" class="flex flex-row space-x-2">
                            <p class="text-white font-bold pt-2">Already have Cell C Fibre?</p><br>
                            <a class="text-white font-bold pt-2 hover:text-black transition ease-in-out duration-300"
                                [routerLink]="['/sign-in']" (click)="onLoginClick('Sign in')">
                                <u>Sign in</u>
                            </a>
                        </div>
                    </div> 
                </div>
        </div>
    </div>
</div>

<!-- <app-footer></app-footer> -->